export enum Routes {
	TemplatePreview = 'TEMPLATE_PREVIEW',
	ConfluenceActivating = 'CONFLUENCE_ACTIVATING',
	ConfluenceActivatingOnDemand = 'CONFLUENCE_ACTIVATING_ONDEMAND',
	ConnectSpace = 'CONNECT_SPACE',
	ServerError = 'SERVER_ERROR',
	ServerErrorAccess = 'SERVER_ERROR_ACCESS',
	SpaceOrPageNotFound = 'SPACE_OR_PAGE_NOT_FOUND',
	ConfluenceTree = 'CONFLUENCE_TREE',
}
